import type { MainCategory } from 'src/types/categories';

import { useContext, createContext } from 'react';

import { useCollectionData } from 'src/hooks/useCollectionData';

import { COLLECTIONS } from 'src/lib/consts';

const ProductMainCategoriesContext = createContext<{
  data: MainCategory[];
  loading: boolean;
  error: any;
}>({
  data: [],
  loading: false,
  error: null,
});

export function useProductMainCategories() {
  return useContext(ProductMainCategoriesContext);
}

export function ProductMainCategoriesProvider({ children }: { children: React.ReactNode }) {
  const value = useCollectionData<MainCategory>({
    collectionName: COLLECTIONS.item_main_categories,
  });

  return (
    <ProductMainCategoriesContext.Provider value={value}>
      {children}
    </ProductMainCategoriesContext.Provider>
  );
}
